<ion-header>
  <ion-toolbar color="medium">
    <ion-title style="color: white;">Classification Inference Result</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeModal('close')">
        <ion-icon style="color: white;" name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" style="border: rgb(188, 183, 183) 2px solid;">
  <ion-card class="custom-card">

    <ion-card-content>
      <ion-label color="medium"><strong>Question</strong></ion-label>
      <p class="text-box">{{ data.question }}</p>

      <ion-label color="medium"><strong>User Answer</strong></ion-label>
      <p class="text-box modified-text">{{ data.answer }}</p>

      <ion-label color="medium"><strong>Classified Answer</strong></ion-label>
      <!-- <p class="text-box modified-text">{{ result[0].predicted_label }}</p> -->
      <p class="text-box modified-text">
        {{ result[0]?.predicted_score >= 0.65 ? result[0]?.predicted_label : '' }}
      </p>


      
      
      <!-- <p *ngIf="list_of_available_answer.includes(result[0]?.predicted_label)" style="color: green;">
            The classified answer matches the available answer list.
      </p> -->

      <p *ngIf="result[0]?.predicted_score < 0.65" style="color: red;">
        The model could not classify the user's answer.
      </p>

      <p *ngIf="result[0]?.predicted_score >= 0.65 && list_of_available_answer.includes(result[0]?.predicted_label)" style="color: green;">
        <span style="font-size: 0.95em; color: #333;">Score: {{ (result[0]?.predicted_score * 100) | number:'1.0-2' }}%</span><br>
        The classified answer matches the available answer list. 
      </p>

      <!-- <p *ngIf="!list_of_available_answer.includes(result[0]?.predicted_label)" style="color: red;">
            The classified answer does not match the available answer list.
      </p> -->
      <p *ngIf="result[0]?.predicted_score >= 0.65 && !list_of_available_answer.includes(result[0]?.predicted_label)" style="color: red;">
        The classified answer does not match the available answer list.
      </p>
      

      <ion-select
        [(ngModel)]="correct_answer"
        placeholder="Select an Correct Answer"
      >
        <ion-select-option *ngFor="let item of list_of_available_answer" [value]="item" style="padding: 5px;">
          <span style="padding-left: 5px;">
            {{ item }}
          </span>
        </ion-select-option>
      </ion-select>

      <!-- <ion-label color="medium"><strong>Correct Answer</strong></ion-label>
      <ion-item style="padding: 0px;" lines="inset">
        <ion-input [(ngModel)]="correct_answer" placeholder="Enter correct answer here..." clearInput></ion-input>
      </ion-item> -->

    </ion-card-content>
  </ion-card>

  <div class="button-group">
    <ion-button expand="block" color="primary" (click)="saveAnswer()">
      <!-- <ion-icon name="save-outline" slot="start"></ion-icon> -->
      <ion-icon slot="start"></ion-icon>
      Save
    </ion-button>
    <!-- <ion-button expand="block" color="medium" (click)="closeModal('close')">
      <ion-icon name="close-circle-outline" slot="start"></ion-icon>
      Cancel
    </ion-button> -->
  </div>
</ion-content>
